import { render } from "./SubmitSelectionButton.vue?vue&type=template&id=65b89cc4"
import script from "./SubmitSelectionButton.vue?vue&type=script&lang=js"
export * from "./SubmitSelectionButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/jannie/Projects/alice-stone/alice-stone-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__